/**
 * Authorization Roles
 */
export const authRoles = {
    admin    : ['admin'],
    guestOnly: ['guest'],
};


// WEBPACK FOOTER //
// ./src/auth/auth.js